<template>
    <div class="text-h6 mb-2">
        {{label}}
        <help-tip :text="help_text" />
    </div>
</template>

<script>
import HelpTip from './HelpTip.vue'

export default {
    name: "FieldLabel",
    props: ['label', 'help_text'],
    components: { HelpTip }
}
</script>
